import { IColumns } from '../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: '/users-for-admin',
  columns: [
    {
      id: 'name',
      label: 'NAME',
    },
    {
      id: 'role',
      label: 'USER TYPE',
      // eslint-disable-next-line
      format: (value: any) => value[0].toUpperCase() + value.slice(1),
    },
    {
      id: 'oneButton',
      label: '',
    },
  ],
}
